import {
    Button,
    Flex,
    Icon,
    Icons,
    ThemeIconSizeVariable,
    ThemeSpaceVariable,
} from "@caspeco/casper-ui-library";
// eslint-disable-next-line caspeco-react/discourage-chakra-import
import { useBreakpointValue } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

interface ISideNavigationHeader {
    onClose: () => void;
}
export function SideNavigationHeader({ onClose }: ISideNavigationHeader) {
    const { t } = useTranslation();
    const iconSize = useBreakpointValue({
        base: ThemeIconSizeVariable.Medium,
        md: ThemeIconSizeVariable.Large,
    });

    return (
        <Flex
            align="center"
            w="100%"
            px={ThemeSpaceVariable.Medium}
            py={ThemeSpaceVariable.Small}
            mb={ThemeSpaceVariable.Medium}
        >
            <Flex py={ThemeSpaceVariable.Medium}>
                <Button
                    aria-label={t("action_close")}
                    key={iconSize}
                    onClick={onClose}
                    type="button"
                    variant="secondary"
                    size="lg"
                    w="40px"
                >
                    <Icon icon={Icons.Close} size={iconSize} />
                </Button>
            </Flex>
        </Flex>
    );
}
